import MstRoleComponent from '../Components/Master/Role.tsx';
import { getPageFunction, pageEnum } from '../../security/LoginDetail.js';

export default function MstRole(){
    const pageFunction = getPageFunction({pageId : pageEnum.MstRole});
    return (        
        <MstRoleComponent pageFunction={pageFunction} />
    );
}